import ClassicLayout from './ClassicLayout/ClassicLayout';
import IconLayout from './IconLayout/IconLayout';

export {ClassicLayout, IconLayout};
